import { atom } from 'recoil';

import { SPONSORSHIP_AGREEMENT_MODAL_STEPS } from '../../types/sponsorshipAgreementModals';

export const sponsorshipAgreementActiveModal = atom<SPONSORSHIP_AGREEMENT_MODAL_STEPS | null>({
  key: 'sponsorshipAgreementLoadingModalState',
  default: null,
});
